import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import { io } from 'socket.io-client';
import { useEffect, useState } from 'react';
import FakeStackOverflow from './components/fakestackoverflow';
import { FakeSOSocket } from './types';

const container = document.getElementById('root');

const App = () => {
  const [socket, setSocket] = useState<FakeSOSocket | null>(null);

  const serverURL = process.env.REACT_APP_SERVER_URL;
  const clientID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  const ghClientID = process.env.REACT_APP_GH_CLIENT_ID;
  const googleRedirectURI = process.env.REACT_APP_GOOGLE_REDIRECT_URI;

  if (serverURL === undefined) {
    throw new Error("Environment variable 'REACT_APP_SERVER_URL' must be defined");
  }

  if (clientID === undefined) {
    throw new Error("Environment variable 'REACT_APP_GOOGLE_CLIENT_ID' must be defined");
  }

  if (ghClientID === undefined) {
    throw new Error("Environment variable 'REACT_APP_GH_CLIENT_ID' must be defined");
  }

  if (googleRedirectURI === undefined) {
    throw new Error("Environment variable 'REACT_APP_GOOGLE_REDIRECT_URI' must be defined");
  }

  useEffect(() => {
    if (!socket) {
      setSocket(io(serverURL));
    }

    return () => {
      if (socket !== null) {
        socket.disconnect();
      }
    };
  }, [socket, serverURL]);

  return (
    <Router>
      <FakeStackOverflow socket={socket} />
    </Router>
  );
};

if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(<App />);
}
